import { render, staticRenderFns } from "./NewUserRegist.vue?vue&type=template&id=48bbfb0f&"
import script from "./NewUserRegist.vue?vue&type=script&lang=js&"
export * from "./NewUserRegist.vue?vue&type=script&lang=js&"
import style0 from "./NewUserRegist.vue?vue&type=style&index=0&id=48bbfb0f&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports